import { render } from "./match-table.vue?vue&type=template&id=341db67d"
import script from "./match-table.vue?vue&type=script&lang=js"
export * from "./match-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__